module.exports = __webpack_public_path__ + "img/swarm of servants.38c5e136.png";